import { render, staticRenderFns } from "./CouponExchange.vue?vue&type=template&id=6188955d"
import script from "./CouponExchange.vue?vue&type=script&lang=js"
export * from "./CouponExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports